export type ProcessTypes = "template" | "project" | "booking";

export interface EvProcessRelatedAddress extends more.EntityAPIResultExtended {
    c_address_1: string;
    note: string;
    note_internal_use: string;
    order: number;
    ref_address: EvProcessAddress;
    ref_relation_group: EvProcessRelationTypes;
}

export interface EvProcessAddress extends more.EntityAPIResultExtended {
    gDisp_Firstname_Name: string;
}

export interface EvProcessRelationTypes extends more.EntityAPIResultExtended { 
    description: string;
}

export enum EvProcessSEDModes {
    template = "selectTemplateAddresses",
    project = "selectProjectAddresses",
    booking = "selectBookingAddresses"
}

export interface DateValue {
    date: Date, // local Date -- convertiert tu UTC mit Date.prototype.methods .toJSON() && .toISOString() --> wird automatisch ISO/UTC beim JSONStringify !! ()
    timezone: string // Intl.DateTimeFormat().resolvedOptions().timeZone - wenn ohne TimeZoneSelector || TimeZoneSelector._value.timezone
    offsetMinutes: number
}

export interface EvProcess extends more.EntityAPIResultExtended {
    ev_process_name: string;
    date_start: Date;
    date_start_offset: number;
    date_end: Date;
    date_end_offset: number;
    duration: number;
    duration_hours: number;
    duration_minutes: number;
    ref_ev_project: RefProjectEvProcess;
    ref_ev_booking: RefBookingEvProcess;
    ref_pos_ev_serv: RefPosServEvProcess;
    ref_ev_process_status: RefProcessStatusEvProcess;
    ref_ev_room: RefRoomEvProcess;
    ref_alternative_time_text: RefAlternativeTimeEvProcess;
}

export interface EvProcessGroup extends more.EntityAPIResultExtended {

}

export interface RefProjectEvProcess extends more.EntityAPIResultExtended {
    gDisp_1: string;
}

export interface RefBookingEvProcess extends more.EntityAPIResultExtended {
    ev_booking_name: string;
    ref_ev_room: RefRoomEvProcess
}

export interface RefPosServEvProcess extends more.EntityAPIResultExtended {
    gDisp_1: string;
}

export interface RefProcessStatusEvProcess extends more.EntityAPIResultExtended {
    description: string;
}

export interface RefRoomEvProcess extends more.EntityAPIResultExtended {
    description: string;
}

export interface RefAlternativeTimeEvProcess extends more.EntityAPIResultExtended {
    description: string;
}

